import React from "react";
import { Close } from "../../../assets/svg/AllSvg";
import DocsViewer from "../../../commons/DocsViewer";

const FileView = ({ document_type, url, onClose }) => {
  return (
    <div>
      <div className="relative w-80 h-52">
        <button
          type="button"
          className="absolute top-0 right-0 border px-2 py-1.5 shadow-md bg-white rounded-full flex items-center justify-center -translate-y-2 translate-x-2"
          onClick={onClose}
        >
          <Close width={10} />
        </button>
        {document_type === "doc" ? (
          <DocsViewer docUrl={url} />
        ) : (
          <img
            src={url}
            alt="document"
            className="w-full h-full object-cover"
          />
        )}
      </div>
    </div>
  );
};

export default FileView;
